import { render, staticRenderFns } from "./MedicalEducationReport.vue?vue&type=template&id=5c7e91d4"
import script from "./MedicalEducationReport.vue?vue&type=script&lang=js"
export * from "./MedicalEducationReport.vue?vue&type=script&lang=js"
import style0 from "./MedicalEducationReport.vue?vue&type=style&index=0&id=5c7e91d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports